import { A4uDownload as IconComponent } from '@adobe/react-spectrum-workflow/dist/Download.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Download(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}